import React from 'react'
import injectSheet from 'react-jss'

import {
  ArrowButton,
  IconButton,
} from '../../'

class Lightbox extends React.Component {
  static noAction(event) {
    return () => event.stopPropagation()
  }

  constructor() {
    super()
    this.state = {
      activeSlide: 0,
    }

    this.close = this.close.bind(this)
    this.prev = this.prev.bind(this)
    this.next = this.next.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  close() {
    this.setState({
      activeSlide: 0,
    })
    this.props.closeLightbox()
  }

  prev(e) {
    if (e) {
      e.stopPropagation()
    }

    const { elements } = this.props
    const { activeSlide } = this.state

    this.setState({ activeSlide: ((activeSlide - 1) + elements.length) % elements.length })
  }

  next(e) {
    if (e) {
      e.stopPropagation()
    }

    const { elements } = this.props
    const { activeSlide } = this.state

    this.setState({ activeSlide: (activeSlide + 1) % elements.length })
  }

  handleKeyDown(event) {
    if (event.keyCode === 27) {
      this.close()
    }

    if (event.keyCode === 37) {
      this.prev()
    }

    if (event.keyCode === 39) {
      this.next()
    }
  }

  renderImage({ src, title }) {
    const { classes } = this.props
    return (
      <div className={classes.imageContainer}>
        {title && (
          <h2 className={classes.imageTitle}>{title}</h2>
        )}
        <img
          alt="Vollbild"
          className={classes.image}
          src={`${process.env.REACT_APP_BASE_PATH}${src}`}
        />
      </div>
    )
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render() {
    const {
      classes,
      elements,
    } = this.props

    const { activeSlide } = this.state

    return (
      <div
        id="lightbox"
        onClick={this.close}
        onKeyDown={this.handleKeyDown}
        role="button"
        tabIndex={0}
      >
        {elements && Array.isArray(elements) && elements.length > 0 && (
          <div
            className={classes.lightboxContainer}
            style={{ zIndex: (elements ? 1000 : 0) }}
          >
            <div
              className={classes.contentContainer}
              role="button"
              tabIndex={0}
              onClick={this.noAction}
              onKeyDown={this.handleKeyDown}
            >
              <div className={classes.closeContainer}>
                <IconButton
                  handleClick={this.close}
                  large
                  tip="Vollbild schliessen"
                />
              </div>
              {elements.length === 1 && this.renderImage({
                src: elements[0].image,
                title: elements[0].title,
              })}
              {elements.length > 1 && elements.map((element, index) => (
                <div
                  className={`${classes.slide} ${activeSlide === index && 'active'} ${index === 0 && 'first'}`}
                  // eslint-disable-next-line
                  key={`slide-${element.image}-${index}`}
                >
                  {this.renderImage({
                    src: element.image,
                    title: element.title,
                  })}
                </div>
              ))}
              {elements.length > 1 && (
                <React.Fragment>
                  <div className={`${classes.arrow} left`}>
                    <ArrowButton
                      onClick={this.prev}
                      direction="left"
                    />
                  </div>
                  <div className={`${classes.arrow} right`}>
                    <ArrowButton
                      onClick={this.next}
                      direction="right"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

const styles = theme => ({
  lightboxContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 10,
  },
  closeContainer: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 100,
  },
  arrow: {
    position: 'fixed',
    zIndex: 100,
    top: '50%',
    '&.left': {
      left: 0,
    },
    '&.right': {
      right: 0,
    },
  },
  slide: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    zIndex: -1,
    width: '100%',
    height: '100%',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        timingFunction: theme.motion.acceleration,
      },
    ],
    '&.active': {
      opacity: 1,
      zIndex: 1,
    },
    '&.first': {
      position: 'initial',
    },
  },
  imageTitle: {
    width: '100%',
    color: theme.colors.main_2,
    margin: 0,
    padding: `${theme.sizes.gutter}px`,
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: `${theme.sizes.container}px`,
    maxHeight: '80vh',
    objectFit: 'contain',
  },
})

export default injectSheet(styles)(Lightbox)



// WEBPACK FOOTER //
// ./src/modules/core/components/lightbox.jsx